import React, { useState, useEffect, useCallback } from "react";

const API = process.env.REACT_APP_API_URL || "http://localhost:3001";

function PasswordGate({ onAuth }) {
  const [secret, setSecret] = useState("");
  const [show, setShow] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const attempt = async () => {
    if (!secret.trim()) {
      setError("Please enter the admin password.");
      return;
    }
    setBusy(true);
    setError("");
    try {
      const r = await fetch(API + "/api/admin/customers", {
        headers: { "x-admin-secret": secret.trim() },
      });
      if (r.status === 403) {
        setError(
          "Wrong password. Check ADMIN_SECRET in your backend .env file.",
        );
      } else if (r.ok) {
        sessionStorage.setItem("sl_admin", secret.trim());
        onAuth(secret.trim());
      } else {
        setError("Server error " + r.status + ". Check backend terminal.");
      }
    } catch {
      setError("Cannot reach backend at " + API + ". Is it running?");
    }
    setBusy(false);
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#1e2130",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
        fontFamily: "Segoe UI, Arial, sans-serif",
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 4,
          padding: "32px 28px",
          width: "100%",
          maxWidth: 340,
          boxShadow: "0 12px 40px rgba(0,0,0,0.4)",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <span
            style={{
              background: "#009dc4",
              color: "#fff",
              fontWeight: 900,
              fontSize: 11,
              letterSpacing: 2,
              padding: "3px 12px",
              borderRadius: 2,
              display: "inline-block",
              marginBottom: 12,
            }}
          >
            SKILLAUNCH ADMIN
          </span>
          <h1
            style={{
              fontSize: 17,
              fontWeight: 700,
              color: "#1a1a1a",
              margin: 0,
            }}
          >
            Admin sign in
          </h1>
        </div>
        <label style={L}>Admin password</label>
        <div style={{ position: "relative", marginBottom: 8 }}>
          <input
            type={show ? "text" : "password"}
            value={secret}
            autoFocus
            onChange={(e) => setSecret(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && attempt()}
            placeholder="Enter admin secret"
            style={{ ...IN, paddingRight: 52 }}
          />
          <button
            onClick={() => setShow((v) => !v)}
            type="button"
            style={{
              position: "absolute",
              right: 0,
              top: 0,
              bottom: 0,
              width: 48,
              background: "none",
              border: "none",
              cursor: "pointer",
              color: "#888",
              fontSize: 12,
              fontFamily: "inherit",
            }}
          >
            {show ? "Hide" : "Show"}
          </button>
        </div>
        {error && (
          <div
            style={{
              background: "#fff5f5",
              border: "1px solid #fca5a5",
              borderLeft: "3px solid #dc2626",
              borderRadius: 3,
              padding: "8px 10px",
              marginBottom: 10,
            }}
          >
            <p style={{ color: "#dc2626", fontSize: 12, margin: 0 }}>{error}</p>
          </div>
        )}
        <button
          onClick={attempt}
          disabled={busy}
          style={{
            ...BTN,
            width: "100%",
            marginTop: 4,
            padding: "10px 0",
            fontSize: 14,
            background: busy ? "#aaa" : "#009dc4",
          }}
        >
          {busy ? "Checking..." : "Sign in"}
        </button>
        <p
          style={{
            fontSize: 11,
            color: "#aaa",
            textAlign: "center",
            marginTop: 12,
          }}
        >
          For site owner only
        </p>
      </div>
    </div>
  );
}

export default function AdminPage() {
  const [secret, setSecret] = useState(
    () => sessionStorage.getItem("sl_admin") || "",
  );
  const [tab, setTab] = useState("generate");

  if (!secret) return <PasswordGate onAuth={setSecret} />;

  const TABS = [
    { id: "generate", label: "Generate Code" },
    { id: "customers", label: "Customers" },
    { id: "payments", label: "Payment Records" },
    { id: "rewards", label: "Referral Rewards" },
  ];

  return (
    <div
      style={{
        fontFamily: "Segoe UI, Arial, sans-serif",
        minHeight: "100vh",
        background: "#efefef",
      }}
    >
      <div
        style={{
          background: "#1e2130",
          height: 44,
          display: "flex",
          alignItems: "center",
          padding: "0 18px",
          gap: 16,
          position: "sticky",
          top: 0,
          zIndex: 200,
        }}
      >
        <span style={{ fontWeight: 900, fontSize: 15, color: "#fff" }}>
          SkillLaunch
          <span
            style={{
              marginLeft: 8,
              background: "#009dc4",
              color: "#fff",
              fontSize: 9,
              fontWeight: 800,
              letterSpacing: 1.5,
              padding: "2px 6px",
              borderRadius: 2,
              verticalAlign: "middle",
            }}
          >
            ADMIN
          </span>
        </span>
        <div style={{ flex: 1 }} />
        <a
          href="/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#888", fontSize: 12, textDecoration: "none" }}
        >
          View site
        </a>
        <button
          onClick={() => {
            sessionStorage.removeItem("sl_admin");
            setSecret("");
          }}
          style={{
            background: "none",
            border: "1px solid #444",
            borderRadius: 3,
            color: "#aaa",
            fontSize: 12,
            padding: "3px 10px",
            cursor: "pointer",
            fontFamily: "inherit",
          }}
        >
          Lock
        </button>
      </div>

      <div
        style={{
          background: "#fff",
          borderBottom: "2px solid #e0e0e0",
          padding: "0 18px",
          display: "flex",
          overflowX: "auto",
        }}
      >
        {TABS.map((t) => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            style={{
              background: "none",
              border: "none",
              borderBottom:
                tab === t.id ? "2px solid #009dc4" : "2px solid transparent",
              color: tab === t.id ? "#009dc4" : "#555",
              fontWeight: tab === t.id ? 700 : 400,
              fontSize: 13,
              padding: "11px 16px",
              cursor: "pointer",
              fontFamily: "inherit",
              whiteSpace: "nowrap",
              marginBottom: -2,
            }}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div style={{ padding: 18, maxWidth: 1300, margin: "0 auto" }}>
        {tab === "generate" && <GenerateTab secret={secret} />}
        {tab === "customers" && <CustomersTab secret={secret} />}
        {tab === "payments" && <PaymentsTab secret={secret} />}
        {tab === "rewards" && <RewardsTab secret={secret} />}
      </div>
    </div>
  );
}

function GenerateTab({ secret }) {
  const [phone, setPhone] = useState("");
  const [lookup, setLookup] = useState(null);
  const [lookErr, setLookErr] = useState("");
  const [lookBusy, setLB] = useState(false);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  const [err, setErr] = useState("");

  const find = async () => {
    if (!phone.trim()) return;
    setLookErr("");
    setLookup(null);
    setLB(true);
    try {
      const r = await fetch(
        API + "/api/admin/lookup-phone/" + encodeURIComponent(phone.trim()),
        { headers: { "x-admin-secret": secret } },
      );
      const d = await r.json();
      if (!r.ok) {
        setLookErr(d.error);
      } else {
        setLookup(d);
        setEmail(d.email || "");
      }
    } catch {
      setLookErr("Connection failed.");
    }
    setLB(false);
  };

  const generate = async () => {
    setErr("");
    setResult(null);
    if (!email.trim()) {
      setErr("Email is required.");
      return;
    }
    setBusy(true);
    try {
      const r = await fetch(API + "/api/admin/generate-code", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-admin-secret": secret,
        },
        body: JSON.stringify({
          email: email.trim(),
          phone: phone.trim() || undefined,
        }),
      });
      const d = await r.json();
      if (!r.ok) {
        setErr(d.error);
      } else {
        setResult(d);
        setPhone("");
        setEmail("");
        setLookup(null);
      }
    } catch {
      setErr("Connection failed.");
    }
    setBusy(false);
  };

  return (
    <div>
      <STitle>Generate Access Code</STitle>
      <p
        style={{
          fontSize: 13,
          color: "#555",
          marginBottom: 16,
          lineHeight: 1.7,
          maxWidth: 700,
        }}
      >
        When you receive an M-Pesa SMS: enter the paying number to find the
        matching account, confirm the email, then click Generate. Send both
        codes to the client by SMS to their M-Pesa number and any alternative
        number they provided.
      </p>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 14,
          marginBottom: 14,
        }}
      >
        <Card>
          <CTitle>Step 1 — Find account by M-Pesa number</CTitle>
          <p style={H}>
            Enter the number from your M-Pesa SMS to find the matching account.
          </p>
          <label style={L}>M-Pesa number from your SMS</label>
          <div style={{ display: "flex", gap: 6 }}>
            <input
              value={phone}
              placeholder="e.g. 0712345678"
              onChange={(e) => setPhone(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && find()}
              style={{ ...IN, flex: 1, marginBottom: 0 }}
            />
            <button onClick={find} disabled={lookBusy} style={BTN}>
              {lookBusy ? "..." : "Find"}
            </button>
          </div>
          {lookErr && <Err>{lookErr}</Err>}
          {lookup && (
            <div
              style={{
                marginTop: 10,
                background: "#f0f9ff",
                border: "1px solid #bae6fd",
                borderRadius: 4,
                padding: "12px",
              }}
            >
              <p
                style={{
                  fontSize: 10,
                  color: "#0369a1",
                  fontWeight: 800,
                  textTransform: "uppercase",
                  letterSpacing: 1,
                  margin: "0 0 8px",
                }}
              >
                Account found
              </p>
              {[
                ["Name", lookup.name || "Not provided"],
                ["Registered email", lookup.email],
                ["M-Pesa number", lookup.phone],
                ["Alt number", lookup.personal_phone || "Not provided"],
                [
                  "Amount saved",
                  lookup.amount ? "Ksh " + lookup.amount.toLocaleString() : "—",
                ],
                ["Referral used", lookup.referral_code_used || "None"],
                ["Status", lookup.status],
              ].map(([k, v]) => (
                <div
                  key={k}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: 4,
                    fontSize: 12,
                  }}
                >
                  <span
                    style={{ color: "#64748b", flexShrink: 0, marginRight: 8 }}
                  >
                    {k}
                  </span>
                  <span
                    style={{
                      color: "#1a1a1a",
                      fontWeight: 500,
                      textAlign: "right",
                      wordBreak: "break-all",
                    }}
                  >
                    {v}
                  </span>
                </div>
              ))}
            </div>
          )}
        </Card>

        <Card>
          <CTitle>Step 2 — Generate codes</CTitle>
          <p style={H}>Confirm the email is correct then click Generate.</p>
          <label style={L}>Customer registered email *</label>
          <input
            value={email}
            placeholder="customer@email.com"
            onChange={(e) => setEmail(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && generate()}
            style={IN}
          />
          {err && <Err>{err}</Err>}
          <button
            onClick={generate}
            disabled={busy}
            style={{ ...BTN, width: "100%", padding: "10px 0", marginTop: 10 }}
          >
            {busy ? "Generating..." : "Generate access code + referral code"}
          </button>
        </Card>
      </div>

      {result && (
        <div
          style={{
            background: "#f0fdf4",
            border: "1px solid #86efac",
            borderLeft: "4px solid #16a34a",
            borderRadius: 4,
            padding: "16px 18px",
          }}
        >
          <p
            style={{
              fontWeight: 700,
              color: "#16a34a",
              fontSize: 14,
              margin: "0 0 4px",
            }}
          >
            Codes generated for {result.name} ({result.email})
          </p>
          <p style={{ fontSize: 12, color: "#555", margin: "0 0 14px" }}>
            Send both codes via SMS to the client's M-Pesa number and any
            alternative number.
          </p>
          <div
            style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}
          >
            {[
              {
                label: "Access code — unlocks the course",
                val: result.accessCode,
                color: "#1a1a1a",
              },
              {
                label: "Referral code — earns Ksh 500/referral",
                val: result.referralCode,
                color: "#009dc4",
              },
            ].map(({ label, val, color }) => (
              <div
                key={label}
                style={{
                  background: "#fff",
                  border: "1px solid #ddd",
                  borderRadius: 3,
                  padding: "12px 14px",
                }}
              >
                <p
                  style={{
                    fontSize: 10,
                    color: "#888",
                    margin: "0 0 5px",
                    textTransform: "uppercase",
                    letterSpacing: 1,
                    fontWeight: 700,
                  }}
                >
                  {label}
                </p>
                <p
                  style={{
                    fontSize: 22,
                    fontWeight: 900,
                    color,
                    fontFamily: "monospace",
                    letterSpacing: 2,
                    margin: 0,
                  }}
                >
                  {val}
                </p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

function CustomersTab({ secret }) {
  const [rows, setRows] = useState([]);
  const [loading, setL] = useState(true);
  const [search, setSrch] = useState("");

  useEffect(() => {
    fetch(API + "/api/admin/customers", {
      headers: { "x-admin-secret": secret },
    })
      .then((r) => r.json())
      .then((d) => setRows(Array.isArray(d) ? d : []))
      .finally(() => setL(false));
  }, [secret]);

  const filtered = rows.filter(
    (r) =>
      !search.trim() ||
      r.email?.toLowerCase().includes(search.toLowerCase()) ||
      r.name?.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 14,
          marginBottom: 14,
          flexWrap: "wrap",
        }}
      >
        <STitle style={{ margin: 0 }}>Customers ({rows.length})</STitle>
        <input
          value={search}
          onChange={(e) => setSrch(e.target.value)}
          placeholder="Search name or email..."
          style={{ ...IN, maxWidth: 260, marginBottom: 0 }}
        />
      </div>
      {loading ? (
        <Spin />
      ) : (
        <DT
          cols={[
            "Name",
            "Email",
            "Registered",
            "Paid?",
            "Access Code",
            "Referral Code",
            "Referred By",
          ]}
          rows={filtered.map((r) => [
            r.name || "—",
            r.email,
            r.created_at
              ? new Date(r.created_at).toLocaleDateString("en-GB")
              : "—",
            r.access_code ? (
              <Pill c="green">Yes</Pill>
            ) : (
              <Pill c="gray">No</Pill>
            ),
            r.access_code ? <Cd c="#009dc4">{r.access_code}</Cd> : "—",
            r.referral_code ? <Cd>{r.referral_code}</Cd> : "—",
            r.referred_by || "—",
          ])}
          empty="No customers yet."
        />
      )}
    </div>
  );
}

function PaymentsTab({ secret }) {
  const [rows, setRows] = useState([]);
  const [loading, setL] = useState(true);

  useEffect(() => {
    fetch(API + "/api/admin/payments", {
      headers: { "x-admin-secret": secret },
    })
      .then((r) => r.json())
      .then((d) => setRows(Array.isArray(d) ? d : []))
      .finally(() => setL(false));
  }, [secret]);

  const sc = (s) =>
    s === "activated"
      ? "green"
      : s === "completed"
        ? "blue"
        : s === "failed"
          ? "red"
          : "yellow";

  return (
    <div>
      <STitle>Payment Records ({rows.length})</STitle>
      <p
        style={{
          fontSize: 12,
          color: "#666",
          marginBottom: 12,
          lineHeight: 1.7,
        }}
      >
        A record is created as soon as the client enters their M-Pesa number on
        the payment page — before they pay. Status: <strong>pending</strong> =
        number recorded, not yet paid | <strong>completed</strong> = admin
        generated codes | <strong>activated</strong> = client entered code
        successfully
      </p>
      {loading ? (
        <Spin />
      ) : (
        <DT
          cols={[
            "Name",
            "Email",
            "M-Pesa Number",
            "Alt Number",
            "Amount",
            "M-Pesa Transaction",
            "Access Code",
            "Referral Used",
            "Status",
            "Date",
          ]}
          rows={rows.map((r) => [
            r.name || "—",
            r.email,
            r.phone || "—",
            r.personal_phone || "—",
            r.amount ? "Ksh " + r.amount.toLocaleString() : "—",
            r.mpesa_ref ? <Cd>{r.mpesa_ref}</Cd> : "—",
            r.access_code ? <Cd c="#009dc4">{r.access_code}</Cd> : "—",
            r.referral_code_used || "—",
            <Pill c={sc(r.status)}>{r.status}</Pill>,
            r.created_at
              ? new Date(r.created_at).toLocaleDateString("en-GB")
              : "—",
          ])}
          empty="No payment records yet."
        />
      )}
    </div>
  );
}

function RewardsTab({ secret }) {
  const [rows, setRows] = useState([]);
  const [loading, setL] = useState(true);

  const load = useCallback(() => {
    setL(true);
    fetch(API + "/api/admin/rewards", { headers: { "x-admin-secret": secret } })
      .then((r) => r.json())
      .then((d) => setRows(Array.isArray(d) ? d : []))
      .finally(() => setL(false));
  }, [secret]);

  useEffect(() => {
    load();
  }, [load]);

  const markPaid = async (id) => {
    await fetch(API + "/api/admin/rewards/pay", {
      method: "POST",
      headers: { "Content-Type": "application/json", "x-admin-secret": secret },
      body: JSON.stringify({ id }),
    });
    load();
  };

  const pending = rows.filter((r) => r.status === "pending");
  const paid = rows.filter((r) => r.status === "paid");

  return (
    <div>
      <STitle>Referral Rewards</STitle>
      <div
        style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap" }}
      >
        {[
          { label: "Pending", val: pending.length, color: "#d97706" },
          {
            label: "Owed",
            val: "Ksh " + (pending.length * 500).toLocaleString(),
            color: "#dc2626",
          },
          {
            label: "Paid out",
            val: "Ksh " + (paid.length * 500).toLocaleString(),
            color: "#16a34a",
          },
        ].map((k) => (
          <div
            key={k.label}
            style={{
              background: "#fff",
              border: "1px solid #ddd",
              borderLeft: "3px solid " + k.color,
              borderRadius: 4,
              padding: "10px 16px",
              minWidth: 130,
            }}
          >
            <p
              style={{
                fontSize: 10,
                color: "#999",
                margin: "0 0 2px",
                textTransform: "uppercase",
                letterSpacing: 0.8,
                fontWeight: 700,
              }}
            >
              {k.label}
            </p>
            <p
              style={{
                fontSize: 18,
                fontWeight: 900,
                color: k.color,
                margin: 0,
              }}
            >
              {k.val}
            </p>
          </div>
        ))}
      </div>
      {loading ? (
        <Spin />
      ) : (
        <>
          <h3
            style={{
              fontSize: 13,
              fontWeight: 700,
              color: "#333",
              margin: "0 0 10px",
            }}
          >
            Pending ({pending.length}) — send Ksh 500 via M-Pesa to each
            referrer
          </h3>
          {pending.length === 0 ? (
            <p style={{ color: "#aaa", fontSize: 13, marginBottom: 20 }}>
              No pending rewards.
            </p>
          ) : (
            <DT
              cols={[
                "Referrer email",
                "Referred email",
                "Amount",
                "Date",
                "Action",
              ]}
              rows={pending.map((r) => [
                r.referrer_email,
                r.referred_email,
                "Ksh 500",
                r.created_at
                  ? new Date(r.created_at).toLocaleDateString("en-GB")
                  : "—",
                <button
                  key={r.id}
                  onClick={() => markPaid(r.id)}
                  style={{ ...BTN, padding: "4px 12px", fontSize: 12 }}
                >
                  Mark paid
                </button>,
              ])}
              empty=""
            />
          )}
          {paid.length > 0 && (
            <>
              <h3
                style={{
                  fontSize: 13,
                  fontWeight: 700,
                  color: "#888",
                  margin: "20px 0 10px",
                }}
              >
                Paid ({paid.length})
              </h3>
              <DT
                cols={["Referrer email", "Referred email", "Amount", "Paid on"]}
                rows={paid.map((r) => [
                  r.referrer_email,
                  r.referred_email,
                  "Ksh 500",
                  r.paid_at
                    ? new Date(r.paid_at).toLocaleDateString("en-GB")
                    : "—",
                ])}
                empty=""
              />
            </>
          )}
        </>
      )}
    </div>
  );
}

function DT({ cols, rows, empty }) {
  if (rows.length === 0 && empty)
    return (
      <p style={{ color: "#aaa", fontSize: 13, padding: "14px 0" }}>{empty}</p>
    );
  return (
    <div
      style={{
        overflowX: "auto",
        border: "1px solid #d0d0d0",
        borderRadius: 4,
        marginBottom: 16,
      }}
    >
      <table
        style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}
      >
        <thead>
          <tr>
            {cols.map((c, i) => (
              <th
                key={i}
                style={{
                  textAlign: "left",
                  padding: "9px 12px",
                  background: "#282a35",
                  color: "#ddd",
                  fontWeight: 600,
                  fontSize: 12,
                  borderRight:
                    i < cols.length - 1 ? "1px solid #3a3b45" : "none",
                  whiteSpace: "nowrap",
                }}
              >
                {c}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, ri) => (
            <tr
              key={ri}
              style={{ background: ri % 2 === 0 ? "#fff" : "#f9f9f9" }}
            >
              {row.map((cell, ci) => (
                <td
                  key={ci}
                  style={{
                    padding: "8px 12px",
                    borderBottom: "1px solid #eee",
                    borderRight:
                      ci < row.length - 1 ? "1px solid #eee" : "none",
                    verticalAlign: "middle",
                    color: "#333",
                    maxWidth: 200,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function Card({ children }) {
  return (
    <div
      style={{
        background: "#fff",
        border: "1px solid #ddd",
        borderTop: "3px solid #009dc4",
        borderRadius: 4,
        padding: "16px 18px",
      }}
    >
      {children}
    </div>
  );
}
function CTitle({ children }) {
  return (
    <h3
      style={{
        fontSize: 14,
        fontWeight: 700,
        color: "#1e2130",
        margin: "0 0 4px",
      }}
    >
      {children}
    </h3>
  );
}
function STitle({ children, style: s }) {
  return (
    <h2
      style={{
        fontSize: 16,
        fontWeight: 700,
        color: "#1e2130",
        margin: "0 0 14px",
        paddingBottom: 7,
        borderBottom: "2px solid #009dc4",
        display: "inline-block",
        ...(s || {}),
      }}
    >
      {children}
    </h2>
  );
}
function Pill({ c, children }) {
  const m = {
    green: ["#dcfce7", "#16a34a"],
    blue: ["#dbeafe", "#1d4ed8"],
    gray: ["#f3f4f6", "#6b7280"],
    red: ["#fee2e2", "#dc2626"],
    yellow: ["#fef9c3", "#854d0e"],
  };
  const [bg, fg] = m[c] || m.gray;
  return (
    <span
      style={{
        background: bg,
        color: fg,
        fontSize: 11,
        fontWeight: 700,
        padding: "2px 8px",
        borderRadius: 10,
        whiteSpace: "nowrap",
      }}
    >
      {children}
    </span>
  );
}
function Cd({ children, c = "#333" }) {
  return (
    <span style={{ fontFamily: "monospace", fontSize: 12, color: c }}>
      {children}
    </span>
  );
}
function Spin() {
  return (
    <p style={{ color: "#aaa", fontSize: 13, padding: "14px 0" }}>Loading...</p>
  );
}
function Err({ children }) {
  return (
    <p style={{ fontSize: 12, color: "#dc2626", margin: "5px 0 0" }}>
      {children}
    </p>
  );
}

const L = {
  display: "block",
  fontSize: 12,
  fontWeight: 600,
  color: "#444",
  marginBottom: 4,
  marginTop: 10,
};
const IN = {
  width: "100%",
  padding: "8px 10px",
  border: "1px solid #ccc",
  borderRadius: 4,
  fontSize: 13,
  color: "#1a1a1a",
  background: "#fff",
  boxSizing: "border-box",
  marginBottom: 0,
  fontFamily: "inherit",
  outline: "none",
};
const BTN = {
  padding: "8px 16px",
  background: "#009dc4",
  border: "none",
  borderRadius: 4,
  color: "#fff",
  fontSize: 13,
  fontWeight: 700,
  cursor: "pointer",
  fontFamily: "inherit",
  whiteSpace: "nowrap",
};
const H = { fontSize: 12, color: "#777", margin: "0 0 8px", lineHeight: 1.6 };
